import { Link } from "react-router-dom";
import img14 from "../../images/service/gallery11.jpg";
import img15 from "../../images/service/Gallery12.jpg";
import img16 from "../../images/service/gallery13.jpg";
import img17 from "../../images/service/gallery14.jpg";



const GallerySection: React.FC = () => {

    const gallerySets = [
        [img14, img14, img14, img14],
        [img15, img15, img15, img15],
        [img16, img16, img16, img16],
        [img17, img17, img17, img17],

    ];

    return (
        <div>
            <h2 className="details-content-title mt-40 mb-30">Gallery</h2>
        <div className="service-gallary ul_li_between mt-20">
            {gallerySets.map((set, index) => (
                <div className="single-item-image img-hove-effect" key={index}>
                    <div className="xb-img">
                        {set.map((img, i) => (
                            <Link key={i} to="#">
                                <img src={img} alt="gallery" />
                            </Link>
                        ))}
                    </div>
                </div>
            ))}
        </div>
        </div>

    )
}

export default GallerySection;